import React from 'react';

const Input = ({
    type = 'text',
    value,
    onChange,
    onBlur,
    placeholder = '',
    className = '',
    error = false,
    ...props
}) => {
    const baseClasses = `
    !flex !w-full !min-w-0 !flex-1 !resize-none !overflow-hidden !rounded-xl 
    !text-[#121317] focus:!outline-0 focus:!ring-0 !border !bg-white !h-14 
    !placeholder:text-[#676c83] !p-[15px] !text-base !font-normal !leading-normal
  `;

    const borderClasses = error ? '!border-red-500 focus:!border-red-500' : '!border-[#dddee4] focus:!border-[#dddee4]';

    return (
        <input
            type={type}
            className={`${baseClasses} ${borderClasses} ${className}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            {...props}
        />
    );
};

export default Input;
